import React from 'react';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

/** Matches Form Builder standalone (Apple Era) viewport controls. */
export function FormBuilderDesktopIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden {...props}>
      <rect x="2" y="3" width="20" height="14" rx="2" {...strokeProps} />
      <line x1="8" y1="21" x2="16" y2="21" {...strokeProps} />
      <line x1="12" y1="17" x2="12" y2="21" {...strokeProps} />
    </svg>
  );
}

export function FormBuilderTabletIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden {...props}>
      <rect x="4" y="2" width="16" height="20" rx="2" {...strokeProps} />
    </svg>
  );
}

export function FormBuilderMobileIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden {...props}>
      <rect x="6" y="2" width="12" height="20" rx="2" {...strokeProps} />
      <line x1="12" y1="18" x2="12.01" y2="18" {...strokeProps} />
    </svg>
  );
}
